import { z } from "zod"

import {
  branchIdSchema,
  correlationIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
} from "./identifiers.js"

const text = (maximum: number) => z.string().trim().min(1).max(maximum)

export const sandboxCustomerToCashStageV1Schema = z.enum([
  "customer",
  "estimate",
  "approved_scope",
  "work_order_ready",
  "work_scheduled",
  "work_completed",
  "invoice",
  "stripe_checkout",
])

export const sandboxCustomerToCashRequestV1Schema = z.object({
  requestVersion: z.literal(1),
  action: z.enum([
    "prepare",
    "schedule_work",
    "complete_work",
    "prepare_checkout",
  ]),
  correlationId: correlationIdSchema,
  idempotencyKey: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
  legalEntityId: legalEntityIdSchema,
  branchId: branchIdSchema,
  customer: z.object({
    displayName: text(160),
    contactName: text(160),
    email: z.string().trim().email().max(254),
    addressLine1: text(240),
    city: text(120),
    region: text(120),
    postalCode: text(24),
  }).strict(),
}).strict()

export const sandboxCustomerToCashResponseV1Schema = z.object({
  responseVersion: z.literal(1),
  status: z.enum([
    "scheduling_ready",
    "work_ready",
    "work_completed",
    "checkout_ready",
    "conflict",
    "denied",
    "retry",
  ]),
  correlationId: correlationIdSchema,
  completedStages: z.array(sandboxCustomerToCashStageV1Schema),
  failedStage: sandboxCustomerToCashStageV1Schema.nullable(),
  customerId: entityIdSchema.nullable(),
  estimateId: entityIdSchema.nullable(),
  serviceOrderId: entityIdSchema.nullable(),
  visitId: entityIdSchema.nullable(),
  invoiceId: entityIdSchema.nullable(),
  paymentAttemptId: entityIdSchema.nullable(),
  amountMinor: z.number().int().nonnegative().nullable(),
  currency: z.string().regex(/^[A-Z]{3}$/).nullable(),
  checkoutUrl: z.string().url().nullable(),
}).strict()

export type SandboxCustomerToCashRequestV1 = z.infer<
  typeof sandboxCustomerToCashRequestV1Schema
>
export type SandboxCustomerToCashResponseV1 = z.infer<
  typeof sandboxCustomerToCashResponseV1Schema
>
export type SandboxCustomerToCashStageV1 = z.infer<
  typeof sandboxCustomerToCashStageV1Schema
>
